import React from "react";
import Travolta from "../src/pictures/FSLogo/travolta.gif";

const NoResults = (props) => (
  <div>
    <div>
      <div className="noActor">
        <img src={Travolta} alt={"DVD BOX"} className="noActorPicture" />
      </div>
    </div>
    <div className="noActorBox">
      <p className="noActorText">
        Sorry, looks like we don't have what you're looking for.{" "}
        <a
          href="mailto:contact@filmslobs.com"
          style={{
            color: "blue",
            textDecoration: "underline",
            textDecorationStyle: "dotted",
          }}
        >
          Leave us a request.
        </a>
      </p>
    </div>
  </div>
);

export default NoResults;
